import { PAGE_URL_MAX_LENGTH } from './feedbackLimits';
import { FeedbackContext } from './formState';
import { matchAffectedTarget } from './affectedTarget';
import { toOffsetIsoString } from './observedAt';

/** A URL over the limit loses its query string first, which carries the long search filters. */
function fitPageUrl(location: Pick<Location, 'href' | 'origin' | 'pathname'>): string {
    if (location.href.length <= PAGE_URL_MAX_LENGTH) return location.href;
    return `${location.origin}${location.pathname}`.slice(0, PAGE_URL_MAX_LENGTH);
}

export function captureFeedbackContext(
    location: Pick<Location, 'href' | 'origin' | 'pathname' | 'search'>,
    now: Date,
): FeedbackContext {
    return {
        pageUrl: fitPageUrl(location),
        observedAt: toOffsetIsoString(now),
        target: matchAffectedTarget(location.pathname, location.search),
    };
}
